export class BlobModel {
    key: string;
    mimeType: string;
    data: string;
    requiredRoleId: number;
    expiresByUtc: Date;

    constructor(init?: Partial<BlobModel>) {
        Object.assign(this, init);
    }
}
